import { summarize as _summarize, asDate, INDENT, indent, isMultiline } from './_utils.mjs'
function serializeString(s, width) {
  if (width === void 0) {
    width = 80
  }
  var ser = JSON.stringify(s)
  if (ser.length <= width) {
    return ser
  }
  var truncated = s.substring(0, width - 15) + '...'
  ser = JSON.stringify(truncated) + ' [truncated]'
  return ser
}
function serializeArray(annotation, prefix) {
  var items = annotation.items
  if (items.length === 0) {
    return '[]'
  }
  var result = []
  items.forEach(function (item) {
    var _serializeAnnotation = serializeAnnotation(item, '' + prefix + INDENT),
      ser = _serializeAnnotation[0],
      ann = _serializeAnnotation[1]
    result.push('' + prefix + INDENT + ser + ',')
    if (ann !== undefined) {
      result.push(indent(ann, '' + prefix + INDENT))
    }
  })
  return ['['].concat(result, [prefix + ']']).join('\n')
}
function serializeObject(annotation, prefix) {
  var fields = annotation.fields
  var fieldNames = Object.keys(fields)
  if (fieldNames.length === 0) {
    return '{}'
  }
  var result = []
  fieldNames.forEach(function (key) {
    var valueAnnotation = fields[key]
    var kser = serializeValue(key)
    var valPrefix = '' + prefix + INDENT + ' '.repeat(kser.length + 2)
    var _serializeAnnotation2 = serializeAnnotation(valueAnnotation, '' + prefix + INDENT),
      vser = _serializeAnnotation2[0],
      vann = _serializeAnnotation2[1]
    result.push('' + prefix + INDENT + kser + ': ' + vser + ',')
    if (vann !== undefined) {
      result.push(indent(vann, valPrefix))
    }
  })
  return ['{'].concat(result, [prefix + '}']).join('\n')
}
export function serializeValue(value) {
  if (typeof value === 'string') {
    return serializeString(value)
  } else if (typeof value === 'number' || typeof value === 'boolean') {
    return value.toString()
  } else if (value === null) {
    return 'null'
  } else if (value === undefined) {
    return 'undefined'
  } else {
    var valueAsDate = asDate(value)
    if (valueAsDate !== null) {
      return 'new Date(' + JSON.stringify(valueAsDate.toISOString()) + ')'
    } else if (value instanceof Date) {
      return '(Invalid Date)'
    } else {
      return '(unserializable)'
    }
  }
}
export function serializeAnnotation(ann, prefix) {
  if (prefix === void 0) {
    prefix = ''
  }
  var serialized
  if (ann.type === 'array') {
    serialized = serializeArray(ann, prefix)
  } else if (ann.type === 'object') {
    serialized = serializeObject(ann, prefix)
  } else if (ann.type === 'function') {
    serialized = '<function>'
  } else if (ann.type === 'circular-ref') {
    serialized = '<circular ref>'
  } else if (ann.type === 'unknown') {
    serialized = '???'
  } else {
    serialized = serializeValue(ann.value)
  }
  var text = ann.text
  if (text !== undefined) {
    var sep = '^'.repeat(isMultiline(serialized) ? 1 : serialized.length)
    return [serialized, [sep, text].join(isMultiline(text) ? '\n' : ' ')]
  } else {
    return [serialized, undefined]
  }
}
export function formatInline(ann) {
  var _serializeAnnotation3 = serializeAnnotation(ann),
    serialized = _serializeAnnotation3[0],
    annotation = _serializeAnnotation3[1]
  if (annotation !== undefined) {
    return serialized + '\n' + annotation
  } else {
    return serialized
  }
}
export function formatShort(ann) {
  return _summarize(ann, []).join('\n')
}
